<template>
  <BaseListHeader>
    <div class="flex -mx-3">
      <div class="flex-1 px-3">Name</div>
      <div class="flex-1 px-3 text-right">Active Subscriptions</div>
      <div class="w-48" />
    </div>
  </BaseListHeader>
</template>

<script>
export default {
  name: 'ListHeader',
};
</script>
